module.exports = __webpack_public_path__ + "static/media/google.4e00d786.svg";